import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
// @mui
import { Box, Stack, Dialog, Grid, Button, AppBar, Typography, Container, Slide } from '@mui/material';
// components
import { useSettingsContext } from 'src/components/settings/context';
import { setCurrentTreatmentDataGlobal } from 'src/redux/slices/multiTreatment';
import { EditAppointmentPopup } from '../dialogPopUp';
import { clearLead } from '../../redux/slices/lead';
import { dispatch } from '../../redux/store';
import { commonDialogHeaderStyle, onBoardDialogHeader, reminderDialogStyle, reminderTitleStyle, cancelBoxStyle, reminderStackStyle } from '../../styles/ScheduleReminder';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function OpenEditAppointmentPopup({ open, onClose, inputRef, headerButtons, appoinmentSelectData }) {
    const { themeStretch } = useSettingsContext();

    const handleClose = async (action) => {
        if (action === 'save') {
            // await inputRef.current.submit();
        }
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        onClose();
    };

    return (
        <Dialog
            fullScreen
            TransitionComponent={Transition}
            open={open}
            onClose={handleClose}
            sx={reminderDialogStyle}
        >
            <AppBar sx={headerButtons ? commonDialogHeaderStyle : onBoardDialogHeader }>
                <Typography
                    sx={reminderTitleStyle}
                    variant="h6"
                    component="div"
                >
					Appointment reschedule
                </Typography>
                {headerButtons &&
					<Box sx={cancelBoxStyle}>
					    <Button
					        color="inherit"
					        variant='outlined'
					        style={{ borderColor: '#FFFFFF', color: '#fff' }}
					        onClick={() => {handleClose('close');}}
					    >
							Cancel
					    </Button>
					</Box>
                }
            </AppBar>
            <Stack spacing={2} sx={reminderStackStyle}>
                <Grid container spacing={1} sx={{ maxWidth: '1088px', margin: 'auto' }}>
                    <Container
                        maxWidth={themeStretch ? false : 'xl'}
                    >
                        <EditAppointmentPopup handleClose={handleClose} inputRef={inputRef} appoinmentSelectData={appoinmentSelectData} />
                    </Container>
                </Grid>
            </Stack>
        </Dialog>
    );
}

OpenEditAppointmentPopup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    inputRef: PropTypes.any,
    headerButtons: PropTypes.bool,
    appoinmentSelectData: PropTypes.any,
};